export const ForgotPasswordInitialValues = {
  email: '',
};
